/**
 * 表务管理（meterUserRecordList）模块英文映射 · 第 2 组（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/meterUserRecordList/ 下 MeterWaterUsageStatisticsReport、
 * StopRecordList、StopRecoveryList、UserSaleStatementList 及 modules/ 下
 * MeteChangeMeterRecordForm/Modal、MeterAnnualStatementModal、MeterDailyStatementModal、
 * MeterMonthlyStatementModal、MeterPayRecordInvoiceModal、MeterUserPayRecordModal、
 * MeterUserWaterReportDayForm/Modal、MeterUserWaterReportMonthModal、
 * MeterUserinfoTransferRecordForm/Modal
 */
export default {
  // 用水统计报表（MeterWaterUsageStatisticsReport）
  '用水统计报表': 'Water Usage Statistics Report',
  '用水量报表': 'Water Usage Report',
  '用水总量(m³)': 'Total Water Usage (m³)',
  '用水总价(元)': 'Total Water Amount (CNY)',
  '总用水量': 'Total Water Consumption',
  '总用水金额': 'Total Water Amount',
  // 报停记录 / 报停恢复（StopRecordList / StopRecoveryList）
  '操作类型查询': 'Search by operation type',
  '恢复': 'Restore',
  '报停记录': 'Suspension Records',
  '报停时间': 'Suspension Time',
  '报停起始时间': 'Suspension start time',
  '报停结束时间': 'Suspension end time',
  '报停恢复后，该表将恢复正常使用。确定恢复？': 'After restoration, the meter will resume normal use. Are you sure to restore?',
  '恢复成功': 'Restored successfully',
  // 销售汇总报表（UserSaleStatementList）
  '销售汇总报表(附带用户明细)': 'Sales Summary Report (with Customer Details)',
  '附带用户明细导出': 'Export with Customer Details',
  '销售汇总报表': 'Sales Summary Report',
  '营业厅现金总数': 'Business Hall Cash Total',
  '扫码支付现金总数': 'QR Code Payment Cash Total',
  '银联支付现金总数': 'UnionPay Cash Total',
  '微信支付现金总数': 'WeChat Payment Cash Total',
  '充值总数': 'Total Recharge Amount',
  // 换表记录详情（MeteChangeMeterRecordForm）
  '旧表信息': 'Old Meter Info',
  '旧表结算累积流量(m³)': 'Old Meter Settlement Cumulative Flow (m³)',
  '旧表结算剩余金额(元)': 'Old Meter Settlement Remaining Amount (CNY)',
  '新表信息': 'New Meter Info',
  '新表起始读数(m³)': 'New Meter Initial Reading (m³)',
  '换表信息': 'Meter Replacement Info',
  '换表结算剩余金额(元)': 'Settlement Remaining Amount after Replacement (CNY)',
  '故障换表/基表问题': 'Faulty Meter Replacement/Base Meter Problem',
  '故障换表/基表问题/计量问题': 'Faulty Meter Replacement/Base Meter Problem/Metering Problem',
  '故障换表/基表问题/阀门故障': 'Faulty Meter Replacement/Base Meter Problem/Valve Fault',
  '故障换表/基表问题/基表爆裂': 'Faulty Meter Replacement/Base Meter Problem/Base Meter Burst',
  '故障换表/电子问题': 'Faulty Meter Replacement/Electronic Problem',
  '故障换表/电子问题/不上传数据': 'Faulty Meter Replacement/Electronic Problem/No Data Upload',
  '故障换表/电子问题/水表无反应(黑屏、无法激活)': 'Faulty Meter Replacement/Electronic Problem/Meter Unresponsive (black screen, cannot activate)',
  '故障换表/磁干扰': 'Faulty Meter Replacement/Magnetic Interference',
  '故障换表/缺电': 'Faulty Meter Replacement/Power Shortage',
  '故障换表/其他': 'Faulty Meter Replacement/Other',
  // 年报表详情（MeterAnnualStatementModal）
  '年报表详情': 'Annual Report Details',
  '列表数据': 'List Data',
  '图表展示': 'Chart View',
  '月份': 'Month',
  '记录条数': 'Record Count',
  '营收金额(元)': 'Revenue Amount (CNY)',
  '营收金额': 'Revenue Amount',
  // 日报表详情（MeterDailyStatementModal）
  '日报表详情': 'Daily Statement Details',
  '日期': 'Date',
  // 月报表详情（MeterMonthlyStatementModal）
  '月报表详情': 'Monthly Statement Details',
  '交易条数': 'Transaction Count',
  // 发票（MeterPayRecordInvoiceModal）
  '发票代码': 'Invoice Code',
  '请输入发票代码': 'Please enter invoice code',
  '开票人': 'Invoicer',
  '请输入开票人': 'Please enter invoicer',
  '开票时间': 'Invoicing Time',
  '请输入开票时间': 'Please enter invoicing time',
  '备注信息': 'Remarks',
  '请输入发票代码!': 'Please enter the invoice code!',
  '请输入开票人!': 'Please enter the invoicer!',
  '请输入开票日期!': 'Please enter the invoicing date!',
  '开票信息': 'Invoice Info',
  // 缴费详情（MeterUserPayRecordModal）
  '购买量(m³)': 'Purchase Volume (m³)',
  // 日报表表单（MeterUserWaterReportDayForm）
  '用户keyId  对应用户meter_userinfo表的id': 'Customer keyId (id of the meter_userinfo table)',
  '请输入用户keyId  对应用户meter_userinfo表的id': 'Please enter the customer keyId (corresponds to the id in meter_userinfo table)',
  '请选择报表日期': 'Select report date',
  '上报所属月份 六位整数 高四位代表年份 低二位代表月份 格式如202010 ': 'Report month (6-digit integer, top 4 digits = year, last 2 digits = month, e.g. 202010) ',
  '请输入上报所属月份 六位整数 高四位代表年份 低二位代表月份 格式如202010 ': 'Please enter the reported month (6-digit integer, first 4 digits for year, last 2 for month, e.g. 202010)',
  '日冻结用量': 'Daily Frozen Usage',
  '请输入日冻结用量': 'Please enter daily frozen usage',
  '记录一天用各个时间点的吨数': 'Hourly usage volume (tons) of the day',
  '请输入记录一天用各个时间点的吨数': 'Please enter the tonnage at each time point of the day',
  '当天上报数据原始二进制字符串': 'Raw binary string of reported data of the day',
  '请输入当天上报数据原始二进制字符串': 'Please enter the raw binary string of reported data of the day',
  '当天上报数据扩展解析字符串': 'Extended parsed string of reported data of the day',
  '请输入当天上报数据扩展解析字符串': 'Please enter the extended parsed string of reported data of the day',
  '上期时间 主要针对异常情况或者机械表': 'Previous Period time (mainly for abnormal cases or mechanical meters)',
  '请选择上期时间 主要针对异常情况或者机械表': 'Select the Previous Period time (mainly for abnormal cases or mechanical meters)',
  '上期水表累计流量': 'Previous Period Cumulative Meter Flow',
  '请输入上期水表累计流量': 'Please enter the Previous Period cumulative meter flow',
  '本期水表累计流量': 'Current Period Cumulative Meter Flow',
  '请输入本期水表累计流量': 'Please enter the Current Period cumulative meter flow',
  'remark': 'Remark',
  'remarkRes1': 'Remark Res1',
  '请输入remarkRes1': 'Please enter remarkRes1',
  '创建日期': 'Created Date',
  '请选择创建日期': 'Select creation date',
  '请输入创建操作员代码': 'Please enter creator operator code',
  '请选择修改时间': 'Please select modified time',
  '修改操作员Id': 'Updated By Operator Id',
  '请输入修改操作员Id': 'Please enter updater ID',
  // 日报表详情/编辑（MeterUserWaterReportDayModal）
  '确定修改吗?': 'Confirm modification?',
  '日冻结用量(m³)': 'Daily Frozen Usage (m³)',
  '24小时用量分析': '24-hour Usage Analysis',
  '最大值': 'Max',
  '最小值': 'Min',
  // 月用量报表详情（MeterUserWaterReportMonthModal）
  '月用量报表详情': 'Monthly Usage Report Details',
  // 过户记录详情（MeterUserinfoTransferRecordForm）
  '新用户手机号': 'New Customer Mobile Phone',
  '新用户类型名称': 'New Customer Type Name',
  '原用户类型名称': 'Original Customer Type Name',
  '新价格名称': 'New Price Name',
  '原价格名称': 'Original Price Name',
  '新身份类型': 'New Identity Type',
  '原身份类型': 'Original Identity Type',
  '新优惠信息': 'New Discount Info',
  '原优惠信息': 'Original Discount Info',
  '过户原因': 'Transfer Reason',
}
